export default "__VITE_ASSET__4ac6c7b1__"